import { render } from "./product-grid.vue?vue&type=template&id=4a475664&scoped=true"
import script from "./product-grid.vue?vue&type=script&lang=js"
export * from "./product-grid.vue?vue&type=script&lang=js"

import "./product-grid.vue?vue&type=style&index=0&id=4a475664&lang=css"
import "./product-grid.vue?vue&type=style&index=1&id=4a475664&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a475664"]])

export default __exports__